// This file is a slightly modified version of the MIT licensed
// implementation of debounce here:
//
// https://github.com/chodorowicz/ts-debounce/blob/master/src/index.ts
//
// It was modified so that isImmediate is renamed to triggerImmediatelyAsWell
// which when true means that should we trigger a call both immediately
// as soon as debounce is called AND after the delay.

export type Procedure = (...args: any[]) => void;

export type Options = {
  triggerImmediatelyAsWell: boolean;
};

export function debounce<F extends Procedure>(
  func: F,
  waitMilliseconds = 50,
  options: Options = {
    triggerImmediatelyAsWell: false,
  }
): F {
  let timeoutId: number | undefined;

  return function (this: any, ...args: any[]) {
    const context = this;

    const doLater = function () {
      timeoutId = undefined;
      func.apply(context, args);
    };

    const shouldCallNow =
      options.triggerImmediatelyAsWell && timeoutId === undefined;

    if (timeoutId !== undefined) {
      clearTimeout(timeoutId);
    }

    timeoutId = window.setTimeout(doLater, waitMilliseconds);

    if (shouldCallNow) {
      func.apply(context, args);
    }
  } as any;
}
